import { AddThin } from '@shared/assets';
import { IconButton } from '@shared/ui';
import type { IconButtonPT } from '@shared/ui/buttons/icon-button/ui.tsx';

export const ButtonAdd = (props: IconButtonPT): JSX.Element => (
  <IconButton type="button" {...props}>
    <AddThin />
  </IconButton>
);
